import Container from '@/components/Container';
import LessonCard from '@/components/Learn/Lesson';
import Button from '@/components/Button';
import { ArrowPathIcon, PlayIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { useMeditationStore } from '../store/useMeditationStore';

export default function List() {
  const { page, meditations } = useMeditationStore();
  const navigate = useNavigate();

  return (
    <Container className="!mt-sh-60">
      <div className=" col-span-12 lg:col-start-11 lg:col-end-3 ">
        <h3 className=" font-larken text-sh-md">{page?.page?.sectionLabel}</h3>
        <div className="flex flex-col gap-sh-30">
          {meditations?.map((meditation) => {
            const isDone = false;
            const progress = 0;
            return (
              <AnimatedFadeInComponent key={meditation.id}>
                <LessonCard
                  truncateDescription={progress > 0 ? true : false}
                  key={meditation.id}
                  noImage
                  title={meditation.attributes?.title || ''}
                  description={meditation.attributes?.briefDescription || ''}
                  url={`/mindful-exercise/${meditation.attributes?.slug}`}
                  watchLabel={page?.page?.goToTheMeditationBtn}
                  tag={`${meditation?.attributes?.mindful_exercise_type?.data?.attributes?.name || ''}`}
                  duration={meditation?.attributes?.duration || ''}
                  progress={progress}
                  button={
                    <div className="flex items-center gap-4">
                      <Button
                        theme={isDone ? 'outline' : 'solid'}
                        onClick={() => navigate(`/mindful-exercise/${meditation.attributes?.slug}`)}>
                        {isDone ? (
                          <ArrowPathIcon className="inline-block h-4 w-4" />
                        ) : (
                          <PlayIcon className="inline-block h-4 w-4" />
                        )}{' '}
                        {isDone ? 'PLAY AGAIN' : 'PLAY'}
                      </Button>
                    </div>
                  }
                />
              </AnimatedFadeInComponent>
            );
          })}
        </div>
      </div>
    </Container>
  );
}
